import { render } from "./page-configuration.vue?vue&type=template&id=f9a71c7c"
import script from "./page-configuration.vue?vue&type=script&lang=js"
export * from "./page-configuration.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/ALL_REPO/Web-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__